import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["sc-state", [{
      'sc-status-processing': $props.pulse
    }, 'sc-state-bg--' + $props.type]])
  }, null, 2);
}